import { render, staticRenderFns } from "./EventRegistrationList.vue?vue&type=template&id=df7f5b28"
import script from "./EventRegistrationList.vue?vue&type=script&lang=js"
export * from "./EventRegistrationList.vue?vue&type=script&lang=js"
import style0 from "./EventRegistrationList.vue?vue&type=style&index=0&id=df7f5b28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports